// Its own module so links to the assessment tabs don't pull in the scene and everything it renders.
export enum AssessmentViews {
  Overview = 'overview',
  Sections = 'sections',
  Answers = 'answers',
  LocationRisk = 'locationRisk',
  Methodology = 'methodology',
}
